import { useSelector } from 'react-redux';
import { IRootState } from 'rematch/store';

export const useTheme = () => {
	const theme = useSelector((store: IRootState) => store.config.theme);

	return { theme };
};
